export const positions = {
    topLeft: 'top-left',
    bottomLeft: 'bottom-left',
    bottomRight: 'bottom-right',
    topCenter: 'top-center'
}

const defPosition = positions.bottomLeft

export const overrideToastDefaults: any = {
    duration: 4000,
    position: defPosition,

    style: {
        borderRadius: '50px',
        padding: '14px 20px'
    },
    className: '',
    escapeHtml: false,
    enableHtml: true
}

export const overrideToastDownload: any = {
    duration: 5000,
    position: defPosition,

    style: {
        borderRadius: '50px',
        padding: '14px 20px'
    },
    className: '',
}

export const toastMessages = {
    'default': {
        'success': 'Updated successfully',
        'fail': 'Something went wrong. Try reloading the page',
        'notFound': 'Page cannot be found. Try searching',
        'failedToVerify': 'Something went wrong. Try verifying again',
    },
    'Login': {
        'NetworkError': 'Connection error. Contact Systems Administrator',
        'inValidAccount': 'User authentication failed. Invalid account. Please contact the systems administrator',
    },
    'subscription': {
        'new': 'New subscription has been added',
        'activated': 'Subscription has been activated',
        'deactivate': 'Subscription has been deactivated',
        'contactSupport': "Support team has been notified. They'll get back to you."
    },
    'NiraApiNotification': {
        'offline': 'We can not reach the NIRA services at the moment. Please try again later.',
        'online': 'We can successfully reach the NIRA services.',
    },
    'idvVerification': {
        'new': 'New verification request has been made',
        'fail': 'Failed to fetch requests',
        'success': 'Verification requests successfully updated',
        'bulk': 'File has been uploaded successfully. Please follow up on progress later.',
    },
    'onboarding': {
        'new': 'New verification request has been made',
        'fail': 'Failed to fetch requests',
        'success': 'Applications successfully updated',
        'missingProfile': 'Application has no customer profile'
    },
    'applications': {
        'new': 'New application has been submitted',
        'fail': 'Failed to fetch applications',
        'success': 'Applications successfully updated'
    },
    'generatePDF': {
        'fail': 'Failed to download report',
        'success': 'Report successfully downloaded'
    },
    'generateExport': {
        'fail': 'Failed to download export',
        'inProgress': 'Generating export, please wait...',
        'success': 'Export successfully downloaded'
    },
    'markAsReviewed': {
        'fail': 'Failed to update application. Please refresh and try again',
        'success': 'Successfully marked application as reviewed'
    },
    'documentsDownload': {
        'fail': 'Failed to download company document. Please refresh and try again',
        'loading': 'Loading document. Please wait...',
        'downloading': 'Document download initiated. Please wait...',
        'success': 'Successfully downloaded selected document',
        'noDownloadLink': 'Looks like the search is missing a Registration number. Make a new search',
    },
    'searchFilter': {
        'sameDateFilter': 'Adjust the date range to update data',
        'sameSearchFilter': 'Adjust filter to update data',
        'noResults': 'Search returned no results.'
    },
    'AML': {
        'run': 'AML screening has been initiated successfully.',
        're-run': 'AML screening has been re-run.'
    },
    'PEP': {
        'run': 'PEP screening has been initiated successfully.',
        're-run': 'PEP screening has been re-run.'
    },
    'TIN': {
        'run': 'TIN verification has been initiated successfully.'
    },
    'PhoneNumber': {
        'run': 'Phone number verification has been initiated successfully.',
        'mtnVerifyNoNIN': 'MTN Uganda requires a NIN to confirm person identity. Enter ID details'
    },
    'email': {
        'run': 'Email verification has been initiated successfully.',
        're-run': 'Email verification has been re-run.'
    },
    'ID': {
        'run': 'ID verification has been initiated successfully.'
    },
    'BNV': {
        'run': 'Business Name Verification has been initiated successfully.'
    },
    'KCCA': {
        'run': 'KCCA Trade License Verification has been initiated successfully.'
    },
    'verifyAll': {
        'run': 'All verifications have been initiated successfully.'
    },
    'fingerprintScan': {
        'fail': 'Failed to capture fingerprint',
        'success': 'Fingerprint captured successfully',
        'submitted': 'Fingerprint submitted for verification successfully'
    },
    'saveBiometrics': {
        'fail': 'Failed to save biometrics',
        'success': 'Biometrics saved successfully'
    },
    'biometrics': {
        'override': 'Override of the biometric results have been initiated successfully.'
    },
    'documentsUpload': {
        'fail': 'Failed to uploaded document. Please refresh and try again',
        'loading': 'Uploading document. Please wait...',
        'uploading': 'Document uploaded initiated. Please wait...',
        'success': 'Successfully uploaded file',
    },
    'approveAmendment': {
        'fail': 'Failed to failed to approve Amendment.',
        'success': 'Amendment Approved',
        'declined': 'Amendment Declined!',
    },
    'validateId': {
        'fail': 'Failed to submit ID for validation.',
        'success': 'ID submitted for processing. Please wait...'
    },
    'notifications': {
        'markasRead': 'Notification has been marked as read'
    },
}